import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import {
  Button, Card, Collapse, ListGroup,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import SKDGroupItem from './groupItem';
import itemTypes from '../itemTypes';
import { groupsPropType } from '../../hooks';
import GroupEditor, { useGroupEditor } from '../groupEditor';
import Background from '../../../../components/blanks/common/Background';
import corner4 from '../../../../assets/img/illustrations/corner-4.png';

function SKDGroupsList({
  groups, activeGroup, onClick, onDblClick, onDragEnd,
  onSubGroupClick, onChangeHierarchy, onSwapSubgroups, cardText, cardTitle,
}) {
  const [padded, setPadded] = useState(null);
  const onDragEndHandler = useCallback(
    (item) => {
      onDragEnd(item, padded);
    },
    [onDragEnd, padded],
  );
  const [{
    isOver, isOverCurrent, didDrop,
  }, ref] = useDrop({
    accept: [itemTypes.availableField, itemTypes.group],
    drop: (item) => onDragEndHandler(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
      // CanDrop: monitor.canDrop(),
      didDrop: monitor.didDrop(),
    }),
  });

  const setPaddedHandler = useCallback(
    setPadded,
    [setPadded],
  );

  useEffect(() => {
    if ((!isOver && !isOverCurrent && !didDrop) || (isOver && isOverCurrent && !didDrop)) {
      setPadded(null);
    }
  }, [didDrop, isOver, isOverCurrent]);

  const {
    ctxMenu, ctxMenuopened, onCloseCtxMenu, onCtxMenu, onDeleteItem, editDialog, onEditItem,
    onCloseEditDialog, subItems, onRemoveSubGroup, onUpSubgroup, onDownSubgroup,
  } = useGroupEditor({
    onDelete: onDblClick, items: groups, onRemoveSubItem: onSubGroupClick, onSwap: onSwapSubgroups,
  });
  const [helpOpened, setHelpOpened] = useState(false);

  return (
    <div className="w-100 h-100 d-flex flex-column" ref={ref}>
      <Card className="rounded-0 border-bottom">
        <Background
          image={corner4}
          className="bg-card d-none d-sm-block rounded-0"
        />
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between">
            <Card.Title>
              {cardTitle}
            </Card.Title>
            <Button onClick={() => setHelpOpened((o) => !o)} size="sm" variant="link" className="z-1">
              <FontAwesomeIcon icon={faQuestionCircle} bounce={helpOpened} />
            </Button>
          </div>
          <Collapse in={helpOpened}>
            <Card.Text>
              {cardText}
            </Card.Text>
          </Collapse>
        </Card.Body>
      </Card>
      <ListGroup
        className="flex-fill scrollbar fs--1"
      >
        {groups.map((f) => (
          <SKDGroupItem
            subgroups={f.items}
            name={f.name}
            key={f.name}
            onClick={onClick}
            onDblClick={onDblClick}
            onSubGroupClick={onSubGroupClick}
            active={activeGroup === f.name}
            onHover={setPaddedHandler}
            padded={padded === f.name}
            onChangeHierarchy={onChangeHierarchy}
            onCtxMenu={onCtxMenu}
          />
        ))}
        <GroupEditor
          onDeleteItem={onDeleteItem}
          ctxMenuopened={ctxMenuopened}
          ctxMenu={ctxMenu}
          onCloseCtxMenu={onCloseCtxMenu}
          editDialog={editDialog}
          onEditItem={onEditItem}
          onCloseEditDialog={onCloseEditDialog}
          subItems={subItems}
          onRemoveSubGroup={onRemoveSubGroup}
          onUpSubgroup={onUpSubgroup}
          onDownSubgroup={onDownSubgroup}
        />
      </ListGroup>
    </div>
  );
}

SKDGroupsList.propTypes = {
  groups: groupsPropType.isRequired,
  cardTitle: PropTypes.node.isRequired,
  cardText: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubGroupClick: PropTypes.func.isRequired,
  onDblClick: PropTypes.func.isRequired,
  activeGroup: PropTypes.string,
  onDragEnd: PropTypes.func.isRequired,
  onChangeHierarchy: PropTypes.func.isRequired,
  onSwapSubgroups: PropTypes.func.isRequired,
};

SKDGroupsList.defaultProps = {
  activeGroup: null,
};
export default SKDGroupsList;
